import { Message } from "../../../typings/interfaces"

export const getLastMessageIdFromChatParticipant = (userId: string, messages: Message[]) => {
    const messagesFromChatParticipant = messages.filter(message => message.senderId === userId)
    const lastMessageFromChatParticipant = messagesFromChatParticipant[messagesFromChatParticipant.length - 1]
    
    const lastMessageIdFromChatParticipant = lastMessageFromChatParticipant && lastMessageFromChatParticipant.messageId

    return lastMessageIdFromChatParticipant
}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/utils/getLastMessageIdFromChatParticipant.ts